import React from 'react';

const Button = ({ label, onClick = () => {}, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`fredokaOne box-border w-full rounded-[16px] bg-[#FC823E] px-6 py-2 font-normal  text-white shadow-[0px_1px_2px_0px_rgba(255,255,255,0.40)inset,0px_4px_4px_0px_rgba(255,255,255,0.35)inset] ${className} `}
    >
      {label}
    </button>
  );
};

export default Button;
